'use client';

import { c as _c } from "react/compiler-runtime";
import { NextIntlClientProvider } from 'next-intl';
import { report } from '@/errorReporting';
import type { Locale } from '@/i18n/types';
const MISSING_ERROR_CODE_1 = 'MISSING_TRANSLATION';
const MISSING_ERROR_CODE_2 = 'MISSING_MESSAGE';
type TranslationMissingError = Error & ({
  code: typeof MISSING_ERROR_CODE_1;
} | {
  code: typeof MISSING_ERROR_CODE_2;
});
function isTranslationMissingError<T extends Error>(error: Error): error is TranslationMissingError {
  return 'code' in error && (error.code === MISSING_ERROR_CODE_1 || error.code === MISSING_ERROR_CODE_2);
}
export default function TranslationProvider(t0) {
  const $ = _c(5);
  const {
    children,
    messages,
    locale
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = function onError(error) {
      if (isTranslationMissingError(error)) {
        return;
      }
      report(error);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const onError = t1;
  let t2;
  if ($[1] !== children || $[2] !== locale || $[3] !== messages) {
    t2 = <NextIntlClientProvider messages={messages} locale={locale} onError={onError} timeZone="Europe/Berlin">{children}</NextIntlClientProvider>;
    $[1] = children;
    $[2] = locale;
    $[3] = messages;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}